import React from 'react';
import { LegacyIconRenderer } from "../../../../helper/components/LegacyIconRenderer.js";
import styles from "./FabItem.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FabItem({
  icon,
  onClick,
  title
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.text,
      children: title
    }), /*#__PURE__*/_jsx("button", {
      className: styles.fabItem,
      onClick: onClick,
      type: "button",
      children: /*#__PURE__*/_jsx(LegacyIconRenderer, {
        icon: icon
      })
    })]
  });
}